module.exports = __webpack_public_path__ + "media/mypage/images/service/service1-1621fa8f81d063cb33f000cf0ccafaf8.jpg";